export default {"src":"/_next/static/media/search-icon.43d1f0ac.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};